import httpUmbraco from './httpUmbraco'
import httpCommerce from './httpCommerce'
import { getToken } from '@vue/services/jwt.service'

export const getContent = () => {
  return httpUmbraco.get('/api/content/checkout')
}

export const beginCheckout = async () => {
  return httpCommerce.post('/cart/checkout', null, {
    headers: {
      Authorization: `bearer ${await getToken()}`
    }
  })
}

export const getOrder = async () => {
  return httpCommerce.get('/api/order', {
    headers: {
      Authorization: `bearer ${await getToken()}`
    }
  })
}

export const createPaymentIntent = async () => {
  return httpCommerce.post('/api/order/create-payment-intent', null, {
    headers: {
      Authorization: `bearer ${await getToken()}`
    }
  })
}

export const getDeliverySlots = async () => {
  return httpCommerce.get('/api/order/delivery-slots', {
    headers: {
      Authorization: `bearer ${await getToken()}`
    }
  })
}

export const setDeliverySlot = async id => {
  return httpCommerce.put('/api/order/delivery-slot', id, {
    headers: {
      Authorization: `bearer ${await getToken()}`
    }
  })
}

export const setGoogleInfo = async info => {
  return httpCommerce.put('/api/order/ga-info', info, {
    headers: {
      Authorization: `bearer ${await getToken()}`
    }
  })
}

const  mapCustomerToNewFormat = (customer) => {
  return {
    firstName: customer.firstName,
    lastName:  customer.lastName,
    email:  customer.emailAddress,
    phoneNumber: customer.phoneNumber,
    agreeToTerms: customer.terms,
    consentToMarketing: customer.marketing,
    dateOfBirth: customer.dateOfBirth,
    address: {
      line1: `${customer.address.houseNameNumber} ${customer.address.addressLine1}`,
      line2: customer.address.addressLine2,
      town: customer.address.townCity,
      postcode: customer.address.postcodeZip,
      country: customer.address.country
    }
  }
}

export const setCustomerInfo = async customer => {
  const mappedCustomer = mapCustomerToNewFormat(customer);
  
  return httpCommerce.put('/checkout/customer', mappedCustomer, {
    headers: {
      Authorization: `bearer ${await getToken()}`
    }
  })
}

export const setCustomerInfoLegacy = async customer => {
  return httpCommerce.put('/api/order/customer-info', customer, {
    headers: {
      Authorization: `bearer ${await getToken()}`
    }
  })
}

export const setConfirm = async () => {
  return httpCommerce.post('/checkout/confirm', null, {
    headers: {
      Authorization: `bearer ${await getToken()}`
    }
  })
}

export default {
  getContent,
  beginCheckout,
  getOrder,
  getDeliverySlots,
  setDeliverySlot,
  setGoogleInfo,
  setCustomerInfo,
  setCustomerInfoLegacy,
  setConfirm
}
